import assign from 'lodash.assign'

export const SET_LOCATION = 'SET_LOCATION'

const intialState = {
  pathname: ''
}

export default function location (state = intialState, action) {
  switch (action.type) {
    case SET_LOCATION:
      return assign({}, state, action.location)
    default:
      return state
  }
}

export function setLocation (location) {
  return {
    type: SET_LOCATION,
    location
  }
}



// WEBPACK FOOTER //
// ./frontend/scripts/reducers/location.js